import { useQuery } from '@tanstack/react-query';

import type { ProcessCreationDefaultDataDto } from '@/api/generated';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Params = {
  email?: string;
  emailThreadId?: string;
};

export const useGetProcessCreationDefaultData = ({ email, emailThreadId }: Params) => {
  const { processesApi } = useProcessApiClient();
  const { data, isError, isFetching } = useQuery<ProcessCreationDefaultDataDto>({
    enabled: Boolean(email && emailThreadId),
    queryFn: async () => {
      if (!email) throw new Error('Email is required');
      const { data } = await processesApi.getProcessCreationDefaultData(email, emailThreadId);
      return data;
    },
    queryKey: [QueryKeyEnum.PROCESS.CREATION_DEFAULT_DATA, email, emailThreadId],
  });

  return {
    isError,
    isGetting: isFetching,
    processCreationDefaultData: data,
  };
};
